import { api } from 'boot/axios.js'

export async function query(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/dashboard/mobile/detail',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('items', response.data)
    return response
  } catch (e) {
    throw e
  }
}

export async function projects(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/dashboard/projects',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('projectsItems', response.data)
    return response
  } catch (e) {
    throw e
  }
}

export async function statistics(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/dashboard/statistics',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('statistics', response.data)
    return response
  } catch (e) {
    throw e
  }
}

export async function companies(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/companies',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('companies', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function companiesPlatform(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/companies',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('platforms', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}
